/* global Browser */
import { animationEndEventName } from '../lib/helper';
import { debounce } from 'lodash';
import { currentBreakpoint } from '../lib/responsive.js';
//import Browser from '../lib/browser';

const animationEnd = animationEndEventName();

export default class Sticky {

  constructor(el) {

    if (Browser.browser.major === '9' && Browser.isIE) {
      return;
    }

    if (window.CSS && CSS.supports('position: sticky')) {
      el.style.position = 'sticky';
      el.style.zIndex = '2';
      el.style.top = '0';
      return;
    }

    this.el = el;
    this.isActive = false;
    this.offset = 0;

    this.clone = this.el.cloneNode(true);
    this.clone.classList.add('is-sticky-clone');
    this.el.parentNode.insertBefore(this.clone, this.el);

    this.onScrollHandler = this.onScroll.bind(this);
    this.onRemoveClasses = this.removeClasses.bind(this);
    this.onResizeHandler = this.resize.bind(this);

    this.setOffset();
    this.registerEvents();
    this.onScroll();
  }

  registerEvents() {

    window.addEventListener('scroll', this.onScrollHandler, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);
    window.addEventListener('resize', debounce(this.onResizeHandler, 50), false);
  }

  unregisterEvents() {

    window.removeEventListener('scroll', this.onScrollHandler, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);
    window.removeEventListener('resize', this.onResizeHandler, false);
  }

  onScroll() {

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      return;
    }

    if (window.pageYOffset > this.offset) {

      if (this.isActive) {

        return;
      }

      this.clone.classList.add('is-active');
      this.el.classList.add('is-inactive');
      this.isActive = true;

      return;
    }

    if (!this.isActive) {

      return;
    }

    this.isActive = false;

    // TODO: IE9 specific stuff...
    if (animationEnd !== undefined) {

      this.clone.classList.add('was-active');
      this.clone.addEventListener(animationEnd, this.onRemoveClasses);
    }
  }

  resize() {

    this.setOffset();
    this.onScroll();
  }

  setOffset() {

    if (currentBreakpoint === 's' || currentBreakpoint === 'xs') {

      return;
    }

    const bounding = this.el.getBoundingClientRect();
    this.offset = bounding.height;
  }

  removeClasses(e) {

    if (e.animationName === 'slide-out') {

      this.clone.removeEventListener(animationEnd, this.onRemoveClasses);
      this.clone.addEventListener(animationEnd, this.onRemoveResettedClass);

      this.clone.classList.remove('is-active');
      this.clone.classList.remove('was-active');
      this.el.classList.remove('is-inactive');
    }
  }
};
